import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        sites: '=',
        apg: '=',
        surveyManageSites: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'survey.Survey groups' | translate }}</h1>
            <ul class="actions01">
                <li>
                    <a class="btn filter" ng-click="vm.toggleFilter()">{{ 'survey.Filter groups' | translate }}</a>
                </li>
                <li>
                    <a class="btn add" ui-sref="authorized.survey.add()">{{ 'survey.Add survey group' | translate }}</a>
                </li>
                <li>
                    <a class="btn ico-download" ng-click="vm.exportResults()">{{ 'survey.Export results as CSV' | translate }}</a>
                </li>
            </ul>
        </div>
        <form class="form form-filter" ng-submit="vm.applyFilter()" ng-if="vm.showFilter">
            <div class="fields">
                <div class="row row-md">
                    <label class="label">{{ 'filter.Name' | translate }}</label>
                    <div class="items">
                        <input type="text" ng-model="vm.filter.name" class="form-control">
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'survey.Course site' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.sites.options"
                            selected-model="vm.multiFilter.sites.model"
                            extra-settings="vm.multiFilter.sites.settings"
                            events="vm.multiFilter.sites.events"
                            translation-texts="vm.filterTranslations"
                            >
                        </div>
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'survey.Survey group type' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.multiFilter.types.options"
                            selected-model="vm.multiFilter.types.model"
                            extra-settings="vm.multiFilter.types.settings"
                            translation-texts="vm.filterTranslations">
                        </div>
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'course.Course name' | translate }}</label>
                    <div class="items">
                        <input type="text" ng-model="vm.filter.courseName" class="form-control">
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'occurrence.Occurrence name' | translate }}</label>
                    <div class="items">
                        <input type="text" ng-model="vm.filter.occurrenceName" class="form-control">
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'survey.Automated planning group' | translate }}</label>
                    <div class="items">
                        <div ng-dropdown-multiselect=""
                            options="vm.multiFilter.apg.options"
                            selected-model="vm.multiFilter.apg.model"
                            extra-settings="vm.multiFilter.apg.settings"
                            translation-texts="vm.filterTranslations">
                        </div>
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'training.Training name' | translate }}</label>
                    <div class="items">
                        <input type="text" ng-model="vm.filter.trainingName" class="form-control">
                    </div>
                </div>
                <div class="row row-md">
                    <label class="label">{{ 'training.Form' | translate }}</label>
                    <div class="items">
                        <input type="text" ng-model="vm.filter.formName" class="form-control">
                    </div>
                </div>
            </div>
            <ul class="actions01">
            <li><input type="button" class="btn discrete" ng-click="vm.resetFilter()" value="{{ 'filter.Reset' | translate }}"></li>
            <li><input type="submit" class="btn main" value="{{ 'survey.Filter groups' | translate }}"></li>
            </ul>
        </form>
        <pagination-tools list="vm.list"></pagination-tools>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.loading">
            <thead>
                <tr>
                    <th>{{ 'filter.Name' | translate }}</th>
                    <th>{{ 'survey.Course site' | translate }}</th>
                    <th>{{ 'survey.Group deadline' | translate }}</th>
                    <th>{{ 'course.Course name' | translate }}</th>
                    <th>{{ 'survey.Participation' | translate }}</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td><a ui-sref="authorized.survey.detail({ id: item.id })">{{ item.activeI18n.name }}</a></td>
                    <td>
                        <span ng-if="item.type === vm.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY">
                            {{ vm.getSitesText(item) }}
                        </span>
                    </td>
                    <td>{{ vm.MomentService.formatTimeStamp(item.deadline) }}</td>
                    <td>
                        <span
                            ng-if="item.type === vm.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY"
                            uib-tooltip-html="'{{ 'occurrence.Training' | translate }}: {{ item.trainingI18n.name }} </br>
                             {{ 'occurrence.Occurrence' | translate }}: {{ item.occurrence.name }}'">
                            {{ item.courseI18n.name }}
                        </span>
                        <span ng-if="item.type === vm.SURVEY_GROUP_TYPE_ENUM.KEYS.INDEPENDENT_SURVEY">-</span>
                    </td>
                    <td>{{ item.participationCount }}/{{item.participantsCount }}</td>
                    <td class="actions"><a ui-sref="authorized.survey.detail({ id: item.id })" class="btn edit">{{ 'general.Edit' | translate }}</a></td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    `
})
export default class {
    constructor ($translate, lodash, DATATABLES, ListFactory, SurveyGroupResource,
                 MomentService, FilterService, ModalService, SiteService,
                 SURVEY_GROUP_TYPE_ENUM, COURSE_SITE_ACCESS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.SurveyGroupResource = SurveyGroupResource;
        this.FilterService = FilterService;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.SiteService = SiteService;
        this.SURVEY_GROUP_TYPE_ENUM = SURVEY_GROUP_TYPE_ENUM;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
    }

    $onInit () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };

        this.defaultFilter = {
            expand: 'activeI18n,courseI18n,occurrence,trainingI18n,course,course.sites,occurrence.site,occurrence.sites',
            page: 1,
            pageSize: 50
        };

        this.filter = {};
        this.list = this.ListFactory.createWithPagination(this.SurveyGroupResource.getSurveyGroups.bind(this.SurveyGroupResource));
        this.list.fetch(this.defaultFilter, this.filter);

        const typeOptionsSelected = [];
        const typeOptions = [
            { value: this.SURVEY_GROUP_TYPE_ENUM.KEYS.INDEPENDENT_SURVEY, label: this.SURVEY_GROUP_TYPE_ENUM.LABELS.INDEPENDENT_SURVEY },
            { value: this.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY, label: this.SURVEY_GROUP_TYPE_ENUM.LABELS.COURSE_SURVEY }
        ];

        const apgOptionsSelected = [];
        const apgOptions = this.apg.map(apg => {
            return {
                value: apg.id,
                label: apg.name
            };
        });

        const siteOptionsSelected = [];
        const siteOptions = [];

        if (this.SiteService.hasAccessToAllSites(this.sites)) {
            siteOptions.push(this.allSitesOption);
        }

        this.surveyManageSites.map(site => {
            return siteOptions.push({
                value: site.id,
                label: site.name
            });
        });

        this.multiFilter = {
            types: {
                model: typeOptionsSelected,
                options: typeOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            apg: {
                model: apgOptionsSelected,
                options: apgOptions,
                settings: {
                    allowSearchFilter: true,
                    enableSearch: true,
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    allowSearchFilter: true,
                    enableSearch: true,
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                },
                events: {
                    onItemDeselect: this.getItemCallBack(),
                    onItemSelect: this.getItemCallBack()
                }
            }
        };
        this.filterTranslations = this.FilterService.getTranslations();
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    /**
     * Callback function that is called when item is added or removed from selectbox
     * Callback is called before selectionChanged callback
     * @returns {Function}
     */
    getItemCallBack () {
        return item => {
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === null) {
                this.multiFilter.sites.model = [this.allSitesOption];
            }
            else {
                this.multiFilter.sites.model = this.multiFilter.sites.model.filter(model => model.value !== null);
            }
        };
    }

    getSitesText (survey) {
        if (survey.type === this.SURVEY_GROUP_TYPE_ENUM.KEYS.COURSE_SURVEY) {
            if (survey.occurrence.siteAccess === 'ALL_SITES') {
                return survey.occurrence.site ? survey.occurrence.site.name : this.allSitesOption.label;
            }

            if (survey.occurrence.siteAccess === 'SPECIFIED_SITES') {
                const sitesNameList = survey.occurrence.sites.slice(0, 3).map((site) => site.name);
                const siteNamesString = sitesNameList.join(', ');

                if (survey.occurrence.sites.length > 3) {
                    return `${siteNamesString} ...`;
                }

                return siteNamesString;
            }
        }

        if (survey.type === this.SURVEY_GROUP_TYPE_ENUM.KEYS.INDEPENDENT_SURVEY) {
            return '-';
        }

        return '';
    }
    applyFilter () {
        const types = !this.multiFilter.types.model.length ? [] : this.multiFilter.types.model.map(model => model.value);
        const sites = !this.multiFilter.sites.model.length ? [] : this.multiFilter.sites.model.map(model => model.value);
        const plannedGroups = !this.multiFilter.apg.model.length ? [] : this.multiFilter.apg.model.map(model => model.value);
        this.filter = this.lodash.assign(this.filter, { type: types });
        this.filter = this.lodash.assign(this.filter, { siteIds: sites });
        this.filter = this.lodash.assign(this.filter, { plannedGroup: plannedGroups });
        this.filter = this.lodash.assign(this.filter, { name: this.filter.name });
        this.filter = this.lodash.assign(this.filter, { occurrenceName: this.filter.occurrenceName });
        this.filter = this.lodash.assign(this.filter, { trainingName: this.filter.trainingName });
        this.filter = this.lodash.assign(this.filter, { formName: this.filter.formName });
        this.filter = this.lodash.assign(this.filter, { courseName: this.filter.courseName });
        this.list.fetch(this.defaultFilter, this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }

    exportResults () {
        const { sites } = this;
        return this.ModalService.open({
            template: '<modals-survey-export sites="vm.sites" forms="vm.forms" courses="vm.courses" class="wrapper" uib-modal-instance="vm.$uibModalInstance"/>',
            resolve: {
                forms: (FormResource, FORMS_TYPE_ENUM) => {
                    return FormResource.getForms({
                        expand: 'activeI18n',
                        fields: 'id', // expand fields will be included by default
                        pageSize: 0
                    }, {
                        types: [FORMS_TYPE_ENUM.KEYS.SURVEY],
                        formAccessSiteIds: sites.map(site => site.id)
                    }).$promise;
                },
                courses: (CourseResource, COURSE_TRAINING_TYPE_ENUM) => {
                    return CourseResource.getCourses({
                        expand: 'activeI18n,feedbackTrainings',
                        fields: 'id', // expand fields will be included by default
                        pageSize: 0

                    }, {
                        trainingType: COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK,
                        courseAccessSiteIds: sites.map(site => site.id)
                    }).$promise;
                }
            },
            controller (forms, courses, $uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.forms = forms;
                this.courses = courses;
            },
            size: 'medium'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/list/index.js